import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import config from '../../../config';

const Vectordbchunkcount_Modal = () => {

const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
    <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-question-line"></i></span>
          
           {/* Default Modal */}
           <Modal id="myModal"
                    isOpen={modal_standard}
                    toggle={() => {
                        tog_standard();
                    }}
                >
                    <ModalHeader className="modal-title"
                        id="myModalLabel" toggle={() => {
                            tog_standard();
                        }}>
                            Vector DBchunk Count ?
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-muted">{config.tool_tip.vectordbchunkcount}</p>
                    </ModalBody>
                    
                </Modal>
    </>
  )
}

export default Vectordbchunkcount_Modal